import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { filterByTargetSkuClassId } from '../../../../../../Calculations/calculationsSlice';
import RedistributionGenericMultiSelectorFilter from './RedistributionGenericMultiSelectorFilter';
import { useTemplateOrCalculation } from '../../../../../../../hooks/useTemplateOrCalculation';
import { useGetStatsSkuClassesQuery } from '../../../../../Statistics/apiCalculationStatistics';

const TargetSkuClassFilter: React.FC = () => {
  const calculationId = useTemplateOrCalculation().id;
  const { data, isFetching, isError } = useGetStatsSkuClassesQuery({ calculationId });

  const redistributionFilterTargetSkuClassIds = useSelector(
    state => state.calculations.redistributionFilterTargetSkuClassIds,
  );

  const selectorOptions = useMemo(() => {
    if (!data) {
      return [];
    }
    return data
      .filter(item => item.quantityTarget > 0)
      .map(item => ({ id: item.skuClass.id, label: item.skuClass.name }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [data]);

  if (isError) {
    return null;
  }

  return (
    <RedistributionGenericMultiSelectorFilter
      label="Target Sku Class"
      options={selectorOptions}
      value={redistributionFilterTargetSkuClassIds}
      dispatcher={filterByTargetSkuClassId}
      loading={isFetching}
    />
  );
};

export default TargetSkuClassFilter;
